
import React from "react";
import { Link } from "react-router-dom";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { repairDisplayText } from "@/utils/displayText";

interface BlogCardProps {
  title: string;
  excerpt: string;
  slug: string;
  imageSrc: string;
  date?: string;
  isoDate?: string;
}

const BlogCard: React.FC<BlogCardProps> = ({
  title: rawTitle,
  excerpt: rawExcerpt,
  slug,
  imageSrc,
  date,
  isoDate,
}) => {
  const blogPostPath = `/blog/${slug}/`;
  const title = repairDisplayText(rawTitle);
  const excerpt = repairDisplayText(rawExcerpt);

  return (
    <div className="bg-white rounded-2xl shadow-md overflow-hidden card-hover">
      <Link to={blogPostPath} className="block focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-slate-700 focus-visible:[&_img]:outline focus-visible:[&_img]:outline-2 focus-visible:[&_img]:-outline-offset-4 focus-visible:[&_img]:outline-white">
        <AspectRatio ratio={16/9} className="bg-gray-100">
          <img
            src={imageSrc}
            alt={title}
            loading="lazy"
            width="640"
            height="360"
            className="w-full h-full object-cover"
          />
        </AspectRatio>
      </Link>
      <div className="p-6">
        {date && (
          <time dateTime={isoDate || date} className="text-sm text-gray-500 mb-2 block">
            {date}
          </time>
        )}
        <Link to={blogPostPath} className="block rounded focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-slate-700">
          <h3 className="text-xl font-bold mb-2 hover:text-elfGreen-ink transition-colors">{title}</h3>
        </Link>
        <p className="text-gray-700 mb-4 line-clamp-3">{excerpt}</p>
        <Link
          to={blogPostPath}
          className="rounded text-elfGreen-ink font-semibold hover:underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-slate-700"
          aria-label={`Read more about ${title}`}
        >
          Read more about this post →
        </Link>
      </div>
    </div>
  );
};

export default BlogCard;
